//--------------------------------------------
//
// Handles webcam video
//
//--------------------------------------------
'use strict';

import q from 'q';


const Video = () => {

	const videoDom = document.getElementById('video');
	const deferred = q.defer();

	navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;

	if (navigator.getUserMedia){
		navigator.getUserMedia({
			video: true
		}, handleVideo, videoError);
	}

	else{
		console.log('no navigator');
		deferred.reject('user media not allowed');
	}

	function handleVideo(stream){
		videoDom.src = window.URL.createObjectURL(stream);
		deferred.resolve(videoDom.src);

	}

	function videoError(e){
		console.log('Video not supported');
		deferred.reject(e);
	}


	return deferred.promise;

}


export default Video;

